/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import Backbone from 'backbone';
import i18n from '../../../../../i18n/DashboardBundle.properties';
import i18n2 from 'js-sdk/src/i18n/CommonBundle.properties';
import sidebarTreeLeafTooltipTemplate from '../../../../template/tooltip/sideBarTreeLeafTooltipTemplate.htm';
import repositoryResourceTypes from 'bi-repository/src/bi/repository/enum/repositoryResourceTypes';
import RepositoryChooserDialogFactory from 'bi-repository/src/bi/repository/dialog/resourceChooser/RepositoryChooserDialogFactory';
import settings from '../../../../../settings/treeComponent.settings';
import getHyperlinkResource from '../../../../model/HyperlinkResourceModel';
import dashboardSettings from '../../../../dashboardSettings';
import dashboardComponentTypes from "../../../../enum/dashboardComponentTypes";
import HyperlinkParametersSectionView from "../../../../hyperlink/parameters/view/HyperlinkParametersSectionView";
import dashboardMessageBus from "../../../../dashboardMessageBus";
import dashboardMessageBusEvents from "../../../../enum/dashboardMessageBusEvents";

function isHyperLinkSupported() {
    let type = this.model.get('type');
    return type === "adhocDataView" || type === "reportUnit" || type === "crosstab" || type === "table" || type === "chart";
}

var PropertiesPanelView = Backbone.View.extend({
    initialize: function (options) {
        this.model = options.model;
        this.listenTo(this.model, 'change:outputParameters', this.renderAvailableParameters);
        this.renderAvailableParameters();
        this.getHyperlinkResource = new getHyperlinkResource();
    },
    showRepositoryChooserDialog: function (model) {
        let RepositoryChooserDialog,
            isTreeAvailable = !this.repositoryChooserDialog || !this.repoChooserDialogWithoutDashboard,
            hyperlinkType = model.dashletHyperlinkTarget,
            repositoryDialogProperties = {
                treeBufferSize: parseInt(settings.treeLevelLimit, 10),
                title: i18n['dashboard.dialog.properties.repository.chooser.title'],
                tooltipTemplate: sidebarTreeLeafTooltipTemplate,
                tooltipi18n: i18n2,
                cssClassItemProcessor: function (item) {
                    switch (item.value.resourceType) {
                    case repositoryResourceTypes.REPORT_UNIT:
                        item.cssClass = 'dashboard-existingContent-report';
                        break;
                    case repositoryResourceTypes.ADHOC_DATA_VIEW:
                        item.cssClass = 'dashboard-existingContent-adhoc-wide';
                        break;
                    case repositoryResourceTypes.DASHBOARD:
                        item.cssClass = 'dashboard-existingContent-dashboard';
                        break;
                    case repositoryResourceTypes.REPORT_OPTIONS:
                        item.cssClass = 'dashboard-existingContent-reportOption';
                        break;
                    }
                    return item;
                }
            }

        if(isTreeAvailable) {
            RepositoryChooserDialog = RepositoryChooserDialogFactory.getDialog('item');
        }
        //this dialog box contains dashboard, adhoc views ,reports and report options
        if (!this.repositoryChooserDialog) {
            let repositoryChooserDialogProps = _.extend({}, repositoryDialogProperties, {
                resourcesTypeToSelect: [
                    repositoryResourceTypes.DASHBOARD,
                    repositoryResourceTypes.REPORT_UNIT,
                    repositoryResourceTypes.ADHOC_DATA_VIEW,
                    repositoryResourceTypes.REPORT_OPTIONS
                ]
            });
            this.repositoryChooserDialog = new RepositoryChooserDialog(repositoryChooserDialogProps);
        }

        // this dialog contains report options, report and adhoc views
        if (!this.repoChooserDialogWithoutDashboard && isHyperLinkSupported.call(this)) {
            let repoChooserDialogWithoutDashboardProps = _.extend({}, repositoryDialogProperties, {
                resourcesTypeToSelect: [
                    repositoryResourceTypes.REPORT_OPTIONS,
                    repositoryResourceTypes.REPORT_UNIT,
                    repositoryResourceTypes.ADHOC_DATA_VIEW
                ]
            });
            this.repoChooserDialogWithoutDashboard = new RepositoryChooserDialog(repoChooserDialogWithoutDashboardProps);
        }

        hyperlinkType === dashboardSettings.DASHLET_REPLACE_ACTION ? this.repoChooserDialogWithoutDashboard.open() : this.repositoryChooserDialog.open();
    },
    renderAvailableParameters: function () {
        var self = this, type = this.model.get('type');
        if (type === dashboardComponentTypes.FREE_TEXT || type === dashboardComponentTypes.IMAGE) {
            if (!this.hyperlinkParametersSectionView) {
                this.hyperlinkParametersSectionView = new HyperlinkParametersSectionView();
                this.listenTo(this.hyperlinkParametersSectionView.collection, 'add change remove', function () {
                    self.model.set('outputParameters', self.hyperlinkParametersSectionView.toJSON(), {silent: true});
                });
            }
            this.hyperlinkParametersSectionView.reset(this.model.get('outputParameters'));
        }
    },
    showRepositoryChooserFileDialog: function (setUrl) {
        if (!this.repositoryChooserFileDialog) {
            var RepositoryChooserDialog = RepositoryChooserDialogFactory.getDialog('item'), extensions = [
                '.pdf',
                '.docx',
                '.html',
                '.ods',
                '.odt',
                '.csv',
                '.pptx',
                '.rtf',
                '.xls',
                '.xlsx',
                '.svg',
                '.xml',
                '.jar',
                '.jrxml',
                '.cur',
                '.jrtx',
                '.properties',
                '.css',
                '.eot',
                '.ttf',
                '.woff'
            ];
            this.repositoryChooserFileDialog = new RepositoryChooserDialog({
                title: i18n['dashboard.dialog.properties.repository.chooser.title'],
                treeBufferSize: parseInt(settings.treeLevelLimit, 10),
                resourcesTypeToSelect: ['img'],
                resourcesTypeToSelectTree: ['file'],
                tooltipTemplate: sidebarTreeLeafTooltipTemplate,
                tooltipi18n: i18n2,
                cssClassItemProcessor: function (item) {
                    if (item.value.resourceType === repositoryResourceTypes.FILE && !_.find(extensions, function (ext) {
                        return item.value.label.toLowerCase().endsWith(ext);
                    })) {
                        item.cssClass = 'dashboard-newContent-image';
                    }
                    return item;
                }
            });
            this.listenTo(this.repositoryChooserFileDialog, 'close', function () {
                if (this.repositoryChooserFileDialog.selectedResource && this.repositoryChooserFileDialog.selectedResource.resourceUri) {
                    var val = {url: 'repo:' + this.repositoryChooserFileDialog.selectedResource.resourceUri};
                    this.model.set(val);
                    setUrl(val.url);
                    this.model.validate(val);
                }
            }, this);
        }
        this.repositoryChooserFileDialog.open();
    },
    showFilterManagerConfirmationDialog: function () {
        dashboardMessageBus.trigger(dashboardMessageBusEvents.OPEN_FILTER_MANAGER);
    },
});

export default PropertiesPanelView;
